import React, { Component } from 'react';

import {
  SCREEN_ID_SUNSETUP_DRIVER_ORDER,
} from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrSunSetupDriverOrder from 'client/components/SrSunSetupDriverOrder/SrSunSetupDriverOrder';

@withTransitionHook
@withScreenId(SCREEN_ID_SUNSETUP_DRIVER_ORDER)
@withScrollToTop
class SunSetupDriverOrderPage extends Component {
  render() {
    const {
      match,
      history,
    } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle='Order'
        backUrl={`/sunsetup/drivers/${match.params.driverId}/orders`}
        redirectToLastLocation={false}
      >
        <SrSunSetupDriverOrder
          driverId={parseInt(match.params.driverId, 10)}
          orderId={parseInt(match.params.orderId, 10)}
          history={history}
        />
      </SrPartnerPageV2>
    );
  }
}

SunSetupDriverOrderPage.displayName = 'SunSetupDriverOrderPage';

export default SunSetupDriverOrderPage;
